import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import CmsBanner from './CmsBanner.component';

/** @namespace Pwa/Component/Cms/CmsBanner/Container/CmsBannerContainer */
export class CmsBannerContainer extends PureComponent {
    static propTypes = {
        header: PropTypes.string,
        body: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ]),
        linkText: PropTypes.string,
        linkUrl: PropTypes.string,
        desktopImage: PropTypes.string.isRequired,
        mobileImage: PropTypes.string.isRequired,
        imageAlt: PropTypes.string
    };

    static defaultProps = {
        header: '',
        body: '',
        linkText: '',
        linkUrl: '',
        imageAlt: 'CMS Banner'
    };

    render() {
        const {
            header,
            body,
            linkText,
            linkUrl,
            desktopImage,
            mobileImage,
            imageAlt
        } = this.props;

        return (
            <CmsBanner
              header={ header }
              body={ body }
              linkText={ linkText }
              linkUrl={ linkUrl }
              desktopImage={ desktopImage }
              mobileImage={ mobileImage }
              imageAlt={ imageAlt }
            />
        );
    }
}

/** @namespace Pwa/Component/Cms/CmsBanner/Container/mapStateToProps */
export const mapStateToProps = () => ({});

/** @namespace Pwa/Component/Cms/CmsBanner/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CmsBannerContainer);
